export const convertStringToDateArr = (dataArray: any, dateKey: string, deleteHours?: boolean) => {
    return dataArray.map((item: any) => {
        item[dateKey] = convertStringToDate(item, dateKey, deleteHours);
        return item;
    });
};

export const convertStringToDate = (object: any, dateKey: string, deleteHours?: boolean) => {
    if (!object[dateKey]) {
        return null;
    }
    const date = new Date(object[dateKey]);
    if (deleteHours) {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
    }
    return date;
};

export const convertStringToDateStr = (object: any, dateKey: string) => {
    if (!object[dateKey]) {
        return '';
    }
    return formatDate(object[dateKey]);
};
export const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    let dateStr = '';
    if (day < 10) {
        dateStr += `0${day}/`;
    } else {
        dateStr += `${day}/`;
    }
    if (month < 10) {
        dateStr += `0${month}/`;
    } else {
        dateStr += `${month}/`;
    }
    dateStr += `${year}`;
    return dateStr;
};

export class DateUtils {
    public static convertDateForRequest(data: any): any {
        for (const i in data) {
            if (data[i] instanceof Date) {
                data[i] = new Date(data[i].setHours(data[i].getHours() - data[i].getTimezoneOffset() / 60));
            }
        }
        return data;
    }
}
